import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  ButtonGroup,
  DropdownButton,
  MenuItem,
  Modal,
  Checkbox,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getAllCategorys } from "../../../redux/actions/categories";
import { payoutReport, merchantPayoutDetail, markPayment, addPayouComment, getPayoutComment, getPayoutHistory } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util";
const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  payoutReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [],
  scheduleID = [];
class MerchantPayout extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'MERCHANT_PAYOUTS',
      path: ["Home","Merchant Payout Report"],
      links: ["home",'report/merchant-payout' ],
      disabled: false,
      sales: [],
      csvData: "",
      markPaymentPopup : false,
      paymentData: '',
      payAmount: '',
      transactionID: '',
      isLoading: 'false',
      comment: '',
      commentPopup: false,
      historyPopup: false,
      callPopup: '',
      comments: '',
      alertMessage: '',
      payoutHistory: '',
      selectAll: true,
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleMarkPayment = this.handleMarkPayment.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  
  

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    if(this.state.payAmount){
      if(parseInt(this.state.payAmount) > parseInt(this.state.paymentData.totalMerchantPayout)){
        isError = true;
        this.setState({payAmountError: 'red'});
      }
    }
    return isError;
  };

  handleMarkPayment(e) {
    e.preventDefault();
    const err = this.validate();
    if(!err){
      isLoading = "true";
      if(this.state.selectAll == true && isEmpty(scheduleID)){
        if(this.state.paymentData.all_due_payout){
          this.state.paymentData.all_due_payout.map((id, index) => 
            scheduleID.push(id.scheduleID)
          )
        }
      }

      const constData = {
        scheduleID: scheduleID,
        payAmount : (this.state.payAmount) ? this.state.payAmount : this.state.paymentData.totalMerchantPayout,
        transactionID : this.state.transactionID,
        comment: this.state.comment,
      }

      this.props.markPayment(constData);
    }
  }

  handleComment = (e) => {
    e.preventDefault();
    if(this.state.comment){
      let postData = {
        scheduleID : this.state.paymentData.scheduleID,
        comment: this.state.comment,
      }
      this.props.addPayouComment(postData);
    }else{
      this.setState({commentError: 'red'});
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.payoutReport('merchant/merchant-payout', this.props.merchantID);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.paymentStatus !== nextProps.paymentStatus) {
      if (nextProps.paymentStatus) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.paymentStatus.message);
        isLoading = "false";
        this.handleClose();
      }
    }

    if (this.props.getcommentStatus !== nextProps.getcommentStatus) {
      if (nextProps.getcommentStatus) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.getcommentStatus.message);
        isLoading = "false";
        this.handleClose();
      }
    }


    if (this.props.payout !== nextProps.payout) {
      if (nextProps.payout) {
        isLoading = "false";
        this.setState({ payout: nextProps.payout.data });
        this.handleExport(nextProps.payout.data);
      }
    }

    if (this.props.getComment !== nextProps.getComment) {
      if (nextProps.getComment) {
        isLoading = "false";
        this.setState({ comments: nextProps.getComment.data });
      }
    }

    if (this.props.getpayoutSummary !== nextProps.getpayoutSummary) {
      if (nextProps.getpayoutSummary) {
        isLoading = "false";
        this.setState({ historyPopup: true, payoutHistory: nextProps.getpayoutSummary.data});
      }
    }

    if(this.props.paymentData !== nextProps.paymentData){
      if(nextProps.paymentData){
        isLoading = "false";
        this.setState({
          markPaymentPopup: (this.state.callPopup == 'markPaymentPopup') ? true : false,
          commentPopup: (this.state.callPopup == 'commentPopup') ? true : false,
          historyPopup: (this.state.callPopup == 'historyPopup') ? true : false,
          paymentData: nextProps.paymentData.data,
        });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleExport = data => {
    csvData = [
      [
        '#',
        'Merchant Name',
        'Offer ID',
        'Offer Name',
        'Payment Term',
        'Gross Refund',
        'Merchant Refund',
        'Gross Sales',
        'Net Payout',
        'Term Amount',
        'Amount Remaining',
        'Due Date',
      ]
    ];

    if (!isEmpty(data)) {
      data.map((payout, index) => {
        csvData.push([
          ++index,
          payout.merchantFirstName+' '+payout.merchantLastName,
          payout.OfferID,
          payout.OfferName,
          payout.paymentTerm,
          payout.grossRefund,
          payout.refundAmount,
          payout.grossSales,
          payout.netPayout,
          payout.termAmount,
          payout.amountRemaining,
          payout.dueDate,
        ]);
      });
    }

    this.setState({ csvData: csvData });
  };

  markPayment = (e) => {
    let scheduleID = e.target.attributes.getNamedItem("data-key").value;
    isLoading = "true";
    this.setState({callPopup: 'markPaymentPopup'});
    this.props.merchantPayoutDetail(scheduleID);
  }

  paymentHistory = (e) => {
    let scheduleID = e.target.attributes.getNamedItem("data-key").value;
    isLoading = "true";
    this.setState({callPopup: 'historyPopup'});
    this.props.getPayoutHistory(scheduleID);
  }

  paymentComment = (e) => {
    let scheduleID = e.target.attributes.getNamedItem("data-key").value;
    isLoading = "true";
    this.setState({callPopup: 'commentPopup'});
    this.props.merchantPayoutDetail(scheduleID);
    this.props.getPayoutComment(scheduleID);
  }

  handleClose() {
    this.setState({
      markPaymentPopup: false,
      paymentData: '',
      payAmount: '',
      transactionID: '',
      comment: '',
      commentPopup: false,
      historyPopup: false,
      callPopup: '',
      commentError: '',
      scheduleID: '',
      selectAll: true,
    });

    scheduleID = [];
  }

  selectAll = (e) => {
    if(e.target.checked){
      this.setState({selectAll: true});
      if(this.state.paymentData.all_due_payout){
        this.state.paymentData.all_due_payout.map((data, index) => 
          scheduleID.push(data.scheduleID)
        )
      }
    }else{
      this.setState({selectAll: false});
      scheduleID = [];
    }
  }

  checkePaymentSchedule = (e) => {
    scheduleID = (this.state.scheduleID) ? this.state.scheduleID : [];
    let index;

    if (e.target.checked) {
      scheduleID.push(e.target.value);
    } else {
      index = scheduleID.indexOf(e.target.value)
      scheduleID.splice(index, 1)
    }

    this.setState({scheduleID : scheduleID});
  }

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="panel">
          <header className="panel-heading">Merchant Payout
          <span className="pull-right">
              {this.state.csvData ? (
                <CSVLink
                  data={this.state.csvData}
                  filename={"merchant-payout-report.csv"}
                  className="btn btn-danger"
                >
                  Export CSV
                </CSVLink>
              ) : null}
            </span>
          </header>
          <div className="panel-body">
            {this.state.show &&
            this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Merchant Name</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Payment Term</th>
                  <th>Gross Refund</th>
                  <th>Merchant Refund</th>
                  <th>Gross Sales</th>
                  <th>Net Payout</th>
                  <th>Term Amount</th>
                  <th>Amount Remaining</th>
                  <th>Due Date</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(this.state.payout) ? (
                  this.state.payout.map((payout, index) => (
                    <tr eventKey={Math.random()+index}>
                      <td>{++index}</td>
                      <td>{payout.merchantFirstName} {payout.merchantLastName}</td>
                      <td>{payout.OfferID}</td>
                      <td>{payout.OfferName}</td>
                      <td>{payout.paymentTerm}</td>
                      <td>{payout.grossRefund}</td>
                      <td>{payout.refundAmount}</td>
                      <td>{payout.grossSales}</td>
                      <td>{payout.netPayout}</td>
                      <td>{payout.termAmount}</td>
                      <td>{payout.amountRemaining}</td>
                      <td>{payout.dueDate}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="26">Data Not Available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Modal show={this.state.markPaymentPopup} bsSize="large" onHide={this.handleClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>Make Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup>
                <ControlLabel>Offer : {this.state.paymentData.OfferName}</ControlLabel>
              </FormGroup>
              <FormGroup>
                <ControlLabel>Merchant  :  {this.state.paymentData.merchantName}</ControlLabel>
              </FormGroup>
              <FormGroup>
                <h4>Offer Detail</h4>
                <hr/>
              </FormGroup>
              <FormGroup>
                <p>Offer ID  : {this.state.paymentData.OfferID}</p>
              </FormGroup>
              <FormGroup>
                <p>Original Price  : {this.state.paymentData.originPrice}</p>
              </FormGroup>
              <FormGroup>
                <p>Offer Price  : {this.state.paymentData.offerPrice}</p>
              </FormGroup>
              <FormGroup>
                <p>Remittance Per Unit  : {this.state.paymentData.remittancePerUnit}</p>
              </FormGroup>
              <FormGroup>
                <p>Launch Date  : {this.state.paymentData.launchDate}</p>
              </FormGroup>
              <FormGroup>
                <p>End Date  : {this.state.paymentData.endDate}</p>
              </FormGroup>
              <FormGroup>
                <p>Number of Vouchers Sold  : {this.state.paymentData.vouchers_sold}</p>
              </FormGroup>
              <FormGroup>
                <h4>Payment Detail</h4>
                <hr/>
              </FormGroup>
              <FormGroup>
                <p>Gross Sales  : {this.state.paymentData.grossSales}</p>
              </FormGroup>
              <FormGroup>
                <p>Gross Refund : {this.state.paymentData.grossRefund}</p>
              </FormGroup>
              <FormGroup>
                <p>Merchant Refund : {this.state.paymentData.refundAmount}</p>
              </FormGroup>
              <FormGroup>
                <p>Gross CC Fees : </p>
              </FormGroup>
              <FormGroup>
                <p>Shipping To Merchant : {this.state.paymentData.merchantShipping}</p>
              </FormGroup>
              <FormGroup>
                <p>Term Name : {this.state.paymentData.paymentTerm}</p>
              </FormGroup>
              <FormGroup>
                <p>Site Commission : {this.state.paymentData.percent}</p>
              </FormGroup>
              <FormGroup>
                <p>Total Merchant Payout : {this.state.paymentData.totalMerchantPayout}</p>
              </FormGroup>
              <FormGroup>
                <p>Final Merchant Payout : {this.state.paymentData.finalMerchantPayout}</p>
              </FormGroup>
              <FormGroup>
                <p>Total Term Amount Due Merchant : </p>
              </FormGroup>
               <FormGroup>
                <p>Total Term Amount Paid Merchant : </p>
              </FormGroup>
              <FormGroup>
                <h4>Make Payment</h4>
                <hr/>
              </FormGroup>
              <FormGroup>
                <ControlLabel>Enter Amount to Pay Merchant</ControlLabel>
                <FormControl
                    type="text"
                    name="payAmount"
                    value={(this.state.payAmount) ? this.state.payAmount : this.state.paymentData.totalMerchantPayout}
                    onChange={this.handleChange}
                    style={{ borderColor: this.state.payAmountError }}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel>Enter Transaction ID (optional)</ControlLabel>
                <FormControl
                    type="text"
                    name="transactionID"
                    value={this.state.transactionID}
                    onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel>Enter Comment</ControlLabel>
                <FormControl
                    type="text"
                    name="comment"
                    value={this.state.comment}
                    onChange={this.handleChange}
                />
              </FormGroup>

              <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th><Checkbox name="selectAll" onClick={this.selectAll} defaultChecked={this.state.selectAll}></Checkbox></th>
                  <th>Total Term Amount</th>
                  <th>Paid Term Amount</th>
                  <th>Due Date</th>
                </tr>
              </thead>
              <tbody>
                {this.state.paymentData.all_due_payout ?
                  this.state.paymentData.all_due_payout.map((due, index) => 
                    <tr key={due.scheduleID + index}>
                      <td>
                      {(scheduleID.indexOf(due.scheduleID) > -1) ? 
                      <Checkbox name={`scheduleID-${index}`} value={due.scheduleID} defaultChecked={true} onClick={this.checkePaymentSchedule}></Checkbox>
                      :
                      <Checkbox name={`scheduleID-${index}`} value={due.scheduleID} checked={this.state.selectAll} onClick={this.checkePaymentSchedule}></Checkbox>
                      }
                      </td>
                      <td>{due.totalTermAmount}</td>
                      <td>{due.totalPaidAmount}</td>
                      <td>{moment(due.dueDate).format('M-D-Y')}</td>
                    </tr>
                  )
                :
                <tr>
                  <td colSpan="2">Data Not Found</td>
                </tr>
                }
              </tbody>
            </table>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleMarkPayment}>
              Mark As Paid
            </Button>
            <Button bsStyle="default" onClick={() => this.context.router.history.push(`/merchant/w9info/${this.state.paymentData.merchantID}`)}>
              W9 Info
            </Button>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.historyPopup} onHide={this.handleClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>View History</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Amount</th>
                  <th>Transaction ID</th>
                  <th>Comment</th>
                  <th>Paid Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.payoutHistory ?
                  this.state.payoutHistory.map((history, index) => 
                    <tr>
                      <td>{history.pay_amount}</td>
                      <td>{history.transaction_id}</td>
                      <td>{history.comment}</td>
                      <td>{moment(history.created_on).format('M-D-Y')}</td>
                    </tr>
                  )
                :
                <tr>
                  <td colSpan="2">Data Not Found</td>
                </tr>
                }
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.commentPopup} onHide={this.handleClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Comment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Offer : {this.state.paymentData.OfferName}</ControlLabel>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Merchant  :  {this.state.paymentData.merchantName}</ControlLabel>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Enter Comment</ControlLabel>
              <FormControl
                  type="text"
                  name="comment"
                  value={this.state.comment}
                  style={{ borderColor: this.state.commentError }}
                  onChange={this.handleChange}
              />
            </FormGroup>
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>Comment</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {this.state.comments ?
                  this.state.comments.map((comment, index) => 
                    <tr>
                      <td>{comment.comment}</td>
                      <td>{moment(comment.created_at).format('M-D-Y')}</td>
                    </tr>
                  )
                :
                <tr>
                  <td colSpan="2">Data Not Found</td>
                </tr>
                }
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleComment}>
              Submit
            </Button>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantType: state.merchantReducer.merchantType,
    catData: state.categoryReducer.catData,
    payout: state.reportReducer.payout,
    paymentData: state.reportReducer.paymentData,
    paymentStatus: state.reportReducer.paymentStatus,
    getcommentStatus: state.reportReducer.getcommentStatus,
    getComment: state.reportReducer.getComment,
    getpayoutSummary: state.reportReducer.getpayoutSummary,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getMerchantType,
    getAllCategorys,
    merchantPayoutDetail,
    payoutReport,
    markPayment,
    addPayouComment,
    getPayoutComment,
    getPayoutHistory,
  })
)(MerchantPayout);



// WEBPACK FOOTER //
// ./src/app/views/merchant/dashboard/MerchantPayout.js